export const MULTIPAGE_TEMPLATE_SUBMISSION_UNAVAILABLE_PANEL_ID = 'multipage-template-submission-unavailable-panel';

export interface MultipageTemplateSubmissionUnavailablePanelProps {
  posterHashedId: string;
  onClose?(): void;
}
